import axios from '@/axios';
export default (params) => axios.get('dashboard.chart1.dummy.json', {params});
